export default "__VITE_ASSET__DYihvlvN__"